// Unified appearance for every draggable handle in floor mode — measurement
// vertices, wall corners, and door/window grab handles. They all read the same
// way so the interaction model is learn-once:
//   • default / free  → a YELLOW dot
//   • hover           → a WHITE border ring behind the dot
//   • locked          → the dot turns RED (a click toggles yellow ↔ red)
// There's no separate "selected" state for a handle — a click just toggles its
// lock. The border is an enlarged sphere drawn just behind the core (the core
// hides the ring's centre, leaving a clean rim). A door/window's whole BORDER
// turns white on hover and stays white while the opening is selected.
export const VERTEX_FREE = 0xffd23f; // yellow — default / free
export const VERTEX_LOCKED = 0xff5a5a; // red — locked (toggled by a click)
export const VERTEX_SELECTED = 0xffffff; // white — hover ring / selected opening border

// Border sphere is this many times the core radius (a thin rim peeks out behind
// the core). Shared so every system's hover ring matches.
export const BORDER_SCALE = 1.417;
